module.exports = __webpack_public_path__ + "static/fonts/iconfont.37dd359.woff";